

const ROUTES: string[] = [
  'challengeInitializer',
  'challengeList',
  'challengeStateHandler',
  'challengeView',
  'userList',
]

export function isProtectedRoute(value: string): boolean {
  let response = false;

  for (const route of ROUTES) {
    if (value.includes(route)) {
      response = true;
      break;
    }
  }

  return response;
}
